/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXlsx = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M16.9 12.965c.197 0 .392.02.582.06.194.035.363.086.507.15v.75a3.112 3.112 0 0 0-.561-.161c-.19-.04-.367-.06-.529-.06-.219 0-.387.033-.502.098a.32.32 0 0 0-.166.296c0 .1.04.184.123.249.087.06.247.13.481.21l.41.14c.237.08.426.17.566.275a.898.898 0 0 1 .308.367c.065.14.097.311.097.513 0 .244-.06.457-.178.636a1.12 1.12 0 0 1-.508.41 2.09 2.09 0 0 1-.808.14 4.583 4.583 0 0 1-.95-.102 1.56 1.56 0 0 1-.34-.114v-.75c.201.076.403.134.604.173.205.04.401.06.588.06.227 0 .405-.038.534-.114.13-.075.194-.18.194-.312a.279.279 0 0 0-.124-.232c-.082-.065-.243-.137-.48-.216l-.41-.141c-.334-.115-.579-.263-.733-.442-.151-.184-.227-.417-.227-.701 0-.245.061-.455.184-.631.125-.177.301-.312.528-.406a2.05 2.05 0 0 1 .81-.145zm-6.657 1.431.788-1.355h.928l-1.154 1.901 1.214 2.02h-.966l-.875-1.483-.841 1.484h-.928l1.21-2.035-1.15-1.887h.966zm3.047 1.817h1.726v.75h-2.569V13.04h.842zm6.974-1.817.788-1.355h.929l-1.155 1.901 1.214 2.02h-.966L20.2 15.48l-.84 1.483h-.928l1.209-2.034-1.15-1.888h.965z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXlsx as FileXlsx };
